module.exports = __webpack_public_path__ + "static/media/boc-gasses.98b7d0a3.jpg";